import React from 'react';
import { dummyClick } from './utilities';

const YellowButton = ({ text, path, className, disabled, onClick }) => (
  <a
    href={path}
    className={`dib a-subscribe-button white br2 ba no-underline mw5 tc ${disabled ? 'o-50' : ''} ${className} `}
    onClick={onClick}
  >
    {text}
  </a>
);

YellowButton.defaultProps = {
  path: '/',
  text: 'I am a button',
  className: '',
  onClick: dummyClick
};

const UnfilledYellowButton = ({ text, path, className, disabled, onClick, target }) => (
  <a
    href={path}
    className={`dib white br2 ba no-underline mw5 tc ${disabled ? 'o-50' : ''} ${className} `}
    style={{ color: '#ffc100', border: '1px solid #ffc100' }}
    onClick={onClick}
    target={target}
  >
    {text}
  </a>
);

UnfilledYellowButton.defaultProps = {
  path: '/',
  text: 'I am a button',
  className: '',
  onClick: dummyClick,
  target: ''
};

// *******************

const BlueLink = ({ text, path, className, onClick, target }) => (
  <a href={path} className={`dib blue-4 no-underline underline-hover f--2 ${className}`} onClick={onClick} target={target}>
    {text}
  </a>
);

BlueLink.defaultProps = {
  path: '/',
  text: 'I am a link',
  className: '',
  onClick: dummyClick,
  target: ''
};

const WhiteLink = ({ text, path, className, onClick, target }) => (
  <a href={path} className={`white no-underline ${className}`} onClick={onClick} target={target}>
    {text}
  </a>
);

WhiteLink.defaultProps = {
  path: EMPTY_HREF,
  text: 'I am a link',
  className: '',
  onClick: dummyClick,
  target: ''
};

export { YellowButton, UnfilledYellowButton, BlueLink, WhiteLink };
